const LAYERS = ['event', 'playback']

let savedSiteTitle = null
const values = {
  event: null,
  playback: null
}

const trimmed = (title) => (typeof title === 'string' ? title.trim() : '')

const write = () => {
  if (values.playback) {
    document.title = values.playback
    return
  }
  if (values.event) {
    document.title = values.event
    return
  }
  if (savedSiteTitle != null) {
    document.title = savedSiteTitle
    savedSiteTitle = null
  }
}

const rememberSiteTitle = () => {
  if (savedSiteTitle == null && !values.event && !values.playback) {
    savedSiteTitle = document.title
  }
}

export const setDocumentTitleLayer = (layer, title) => {
  if (!LAYERS.includes(layer)) return
  const next = trimmed(title)
  if (!next) {
    clearDocumentTitleLayer(layer)
    return
  }
  rememberSiteTitle()
  values[layer] = next
  write()
}

export const clearDocumentTitleLayer = (layer) => {
  if (!LAYERS.includes(layer)) return
  values[layer] = null
  write()
}
